import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminSession } from '../utils/adminSession';

type RequireAdminProps = {
  children: React.ReactNode;
};

const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  const session = getAdminSession();

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default RequireAdmin;

